import React, { useRef, useEffect, useState } from 'react'
import globals from '../globals'
import Heading from '../components/Heading'
import ModuleWithLoader from '../components/ModuleWithLoader'
import DataSource from '../DataSource'
import ResponsiveTable from '../components/ResponsiveTable'
import FancySelectAdvancedRow from '../elements/FancySelectAdvancedRow'
import CustomLink from '../components/CustomLink'

const ExetelAFriend = (props) => {
    const [isLoaded, setIsLoaded] = useState(false)
    const [hasError, setHasError] = useState(false)
    const [referralData, setReferralData] = useState([])
    const [codeData, setCodeData] = useState([])
    const [currentCode, setCurrentCode] = useState('')
    const container = useRef(null)

    useEffect(() => {
        if (container) {
            globals.animatePageIn(container.current)
        }
        getData()
    }, [])

    const getData = async () => {
        await DataSource.getData('/api/getExetelFriendData', response => {
            setReferralData(response.list)
            mapCodeData(response.codes)
            setIsLoaded(true)
        }, error => {
            setHasError(true)
            setIsLoaded(true)
        })
    }

    const mapCodeData = data => {
        if (data.length > 1) {
            const codes = []
            data.forEach(item => {
                codes.push({ label: item.address, value: item.code })
            })
            setCodeData(codes)
        } else if (data.length === 1) {
            setCurrentCode(data[0].code)
        }
    }

    const mapReferralDataToRows = () => {
        const data = []
        referralData.forEach(item => {
            data.push([item.referee, item.status, item.signedUpDate, `$${globals.addDecimals(item.saved)}`, item.endDate])
        })

        return data
    }

    const handleChangeCode = values => {
        if (values.code) {
            setCurrentCode(values.code)
        }
    }

    const SelectCode = () => {
        return (
            <FancySelectAdvancedRow
                label='Select your service'
                name='code'
                placeholder='Select service to get your code'
                value={currentCode}
                errors={{}}
                options={codeData}
                handleChange={handleChangeCode}
            />
        )
    }

    return (
        <div ref={container} className='exetel-a-friend' style={{ opacity: 0 }}>
            {!hasError
                ? <div className='module' style={{ overflow: 'visible' }}>
                    <Heading title='Exetel-a-friend' />
                    <ModuleWithLoader isLoaded={isLoaded} className='p-4'>
                        <div className='row text-center'>
                            <div className='col-12 col-lg-8 offset-lg-2'>
                                <h1 className='m-0 mt-2 mb-2'>Exetel-a-friend and save</h1>
                                <p className='lh mb-4'>Tell your friends about our award-winning nbn™ broadband and save 10% (up to $10) on yourbroadband plan fee for the next 6 months. The more friends who sign up, the more you save!
                                </p>
                                <h1 className='m-0 mb-2'>Your unique code</h1>
                                <p className='lh'>Below is your unique referral code. Share that code with everyone you know and remind them totype your code into the order form when signing up.
                                </p>
                                {codeData.length > 1 ? <SelectCode /> : ''}
                                {currentCode
                                    ? <div className='text-center'>
                                        <div className='code'>                                            
                                            <CustomLink className='color-darkgrey' to={`https://www.exetel.com.au/broadband/nbn?referral_code=${currentCode}`}>{currentCode}</CustomLink>
                                        </div>
                                      </div>
                                    : ''}
                            </div>
                        </div>
                    </ModuleWithLoader>
                  </div>
                : ''}
            <div className='module'>
                <Heading title='Referrals' />
                <ModuleWithLoader isLoaded={isLoaded} hasError={hasError} className='p-4'>
                    {referralData.length === 0
                        ? <p className='text-center row-success'>You haven't got any referrals yet. Share your code above to get started!</p>
                        : <ResponsiveTable data={{
                            headings: ['Customer', 'Status', 'Signed up date', 'Saving you $ p/mth', 'Savings end'],
                            rows: mapReferralDataToRows()
                        }}
                        />}
                </ModuleWithLoader>
            </div>
            <div className='module p-4 legend'>
                <table width='100%' cellSpacing='4' cellPadding='4'>
                    <thead>
                        <tr>
                            <td className='bold'>Status</td>
                            <td className='bold'>Description</td>
                        </tr>
                    </thead>
                    <tbody>
                        <tr>
                            <td>Pending</td>
                            <td>We have received this signup and will start provisioning soon.</td>
                        </tr>
                        <tr>
                            <td>Active</td>
                            <td>Service is active, you will start seeing savings on your next bill.</td>
                        </tr>
                        <tr>
                            <td>Completed</td>
                            <td>This referral is complete and your benefit has been applied!</td>
                        </tr>
                        <tr>
                            <td>Inactive</td>
                            <td>Unfortunately, this customer cancelled their service and is ineligible for a referral bonus.</td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>
    )
}

export default ExetelAFriend



// WEBPACK FOOTER //
// ./resources/js/pages/ExetelAFriend.js